import { Link } from "react-router-dom";

export default function Logo({ light = false, className = "" }) {
  if (light) {
    // Footer / dark backgrounds: circular mark + cream wordmark for legibility on plum
    return (
      <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
        <img src="/favicon.png" alt="StrongKind Circle" className="h-11 w-11 rounded-full bg-white/95 p-0.5 object-contain" />
        <span className="leading-none">
          <span className="block font-display text-xl font-bold text-cream">StrongKind</span>
          <span className="block font-script text-lg -mt-1 text-rose">Circle</span>
        </span>
      </Link>
    );
  }
  return (
    <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo">
      <img src="/strongkind-logo.png" alt="StrongKind Circle" className="h-11 sm:h-12 w-auto object-contain" />
    </Link>
  );
}
